import { statsigConfig } from '@moojo/shared-config'
import { StatsigClient } from '@statsig/js-client'

export type StatsigEnvironment = 'dev' | 'prod'

export interface StatsigInitOptions {
  userID?: string
  environment?: StatsigEnvironment
}

export async function initStatsig(options: StatsigInitOptions = {}): Promise<StatsigClient> {
  const { userID, environment = 'production' } = options

  const client = new StatsigClient(statsigConfig.clientKey, userID ? { userID } : {}, {
    environment: { tier: environment },
  })

  await client.initializeAsync()
  return client
}
